export function neighbourKey(keys: readonly string[], from: string | null, step: 1 | -1): string | null {
  if (keys.length === 0) return null
  const at = from === null ? -1 : keys.indexOf(from)
  if (at === -1) return step === 1 ? (keys[0] ?? null) : (keys[keys.length - 1] ?? null)
  return keys[at + step] ?? null
}

export function nextOpenKey(
  keys: readonly string[],
  from: string | null,
  isOpen: (key: string) => boolean
): string | null {
  const at = from === null ? -1 : keys.indexOf(from)
  const after = keys.slice(at + 1).find(isOpen)
  if (after !== undefined) return after
  return keys.slice(0, Math.max(at, 0)).find(isOpen) ?? null
}
